/* eslint-disable prefer-named-capture-group */
/* eslint-disable require-unicode-regexp */
export const stripMarkdown = (md: string): string => md
// fenced code blocks ```...```
    .replace(/```[\s\S]*?```/g, (m) => m.replace(/```/g, ''))
// inline code `code`
    .replace(/`([^`]*)`/g, '$1')
// images ![alt](url)
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, '$1')
// links [text](url)
    .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
// headings, blockquotes, list markers at line start
    .replace(/^\s{0,3}(#{1,6}\s+|>\s?|[-*+]\s+|\d+\.\s+)/gm, '')
// bold/italic/strikethrough: **text**, __text__, *text*, _text_, ~~text~~
    .replace(/(\*\*|__)(.*?)\1/g, '$2')
    .replace(/(\*|_)(.*?)\1/g, '$2')
    .replace(/~~(.*?)~~/g, '$1')
// horizontal rules
    .replace(/^\s*([-*_])\s*\1\s*\1[\s\S]*?$/gm, '')
// leftover escape chars
    .replace(/\\([\\`*_{}[\]()#+\-.!>])/g, '$1')
